<template>
  <v-app id="form-cliente" class="primary darken-4">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card>
              <v-toolbar color="primary darken-4" dark>
                <img src="/images/general/agregar-40.png" height="42" alt="Agregar cliente" />
                <v-toolbar-title class="ml-0 pl-3">
                  <span class="hidden-sm-and-down"> AGREGAR CLIENTE </span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="returnHomePage">
                  <v-icon danger>close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-divider></v-divider>
              <v-card-text>
                <v-container grid-list-md>
                  <v-form ref="formCliente" :v-model="true" lazy-validation>
                    <v-layout wrap class="container">
                      <v-flex xs12 sm12 md12>
                        <v-text-field
                          label="Sucursal"
                          v-model="sucursal.nombreSucursal"
                          placeholder="Sucursal del cliente"
                          :readonly="true"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <v-text-field
                          label="Nombre completo"
                          v-model="cliente.nombreCompletoCliente"
                          placeholder="Nombre completo del cliente"
                          :rules="[
                            () =>
                              !!cliente.nombreCompletoCliente ||
                              'El campo es requerido',
                          ]"
                          required
                          @input="cliente.nombreCompletoCliente.toUpperCase()"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <v-text-field
                          label="Domicilio"
                          v-model="cliente.domicilio"
                          placeholder="Donde radica el cliente"
                          hint="Lugar de ubicación"
                          :rules="[
                            () =>
                              !!cliente.domicilio || 'El campo es requerido',
                          ]"
                          required
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm12 md8>
                        <v-text-field
                          label="Colonia"
                          v-model="cliente.colonia"
                          placeholder="Colonia donde radica el cliente"
                          hint="Lugar de ubicación"
                          :rules="[
                            () => !!cliente.colonia || 'El campo es requerido',
                          ]"
                          required
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm12 md4>
                        <v-text-field
                          label="Código postal"
                          v-model="cliente.codigoPostal"
                          :rules="[(v) => v.length <= 5 || 'Máximo 5 dígitos']"
                          maxlength="5"
                          :counter="5"
                          type="number"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <v-select
                          v-model="cliente.paisId"
                          :items="paises"
                          item-text="nombre"
                          item-value="paisId"
                          label="País"
                          placeholder="País"
                          persistent-hint
                          single-line
                        ></v-select>
                      </v-flex>

                       <!-- <v-flex xs1>
                        <v-btn color="primary darken-4"  icon @click.native="reload">
                          <v-icon danger>refresh</v-icon>
                        </v-btn>
                      </v-flex> -->

                      <v-flex xs6>
                        <v-select
                          v-model="cliente.entidadId"
                          :items="entidades"
                          item-text="nombreEntidad"
                          item-value="entidadId"
                          label="Entidad"
                          placeholder="Entidad"
                          single-line
                          @input="getMunicipios"
                          :rules="[
                            () =>
                              !!cliente.entidadId || 'El campo es requerido',
                          ]"
                          required
                        ></v-select>
                      </v-flex>

                      <v-flex xs6>
                        <v-combobox
                          v-model="cliente.municipio"
                          :items="municipios"
                          item-text="nombreMunicipio"
                          :loading="loadingMunicipios"
                          item-value="municipioId"
                          label="Municipio"
                          placeholder="Municipio"
                          single-line
                          :rules="[
                            () =>
                              !!cliente.municipioId || 'El campo es requerido',
                          ]"
                          required
                          @change="setMunicipio"
                        ></v-combobox>
                      </v-flex>

                      <v-flex xs12 sm12 md6>
                        <v-text-field
                          label="Teléfono"
                          v-model="cliente.telefonoParticular"
                          placeholder="Teléfono particular"
                          hint="Teléfono particular"
                          minlenght="16"
                          mask="(###) ### - ####"
                          :rules="[
                            () =>
                              !!cliente.telefonoParticular ||
                              'El campo es requerido',
                            () =>
                              cliente.telefonoParticular.length >= 16 ||
                              'El teléfono debe cumplir con el formato (###) ### - ####.',
                          ]"
                          return-masked-value
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm12 md6>
                        <v-text-field
                          label="Celular"
                          v-model="cliente.telefonoCelular"
                          placeholder="Teléfono celular"
                          hint="Teléfono celular"
                          minlenght="16"
                          mask="(###) ### - ####"
                          :rules="[
                            () =>
                              !!cliente.telefonoCelular ||
                              'El campo es requerido',
                            () =>
                              cliente.telefonoCelular.length >= 16 ||
                              'El teléfono debe cumplir con el formato (###) ### - ####.',
                          ]"
                          return-masked-value
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm12 md12>
                        <v-text-field
                          label="Correo contacto"
                          v-model="cliente.correoContacto"
                          placeholder="Correo electrónico"
                          hint="Correo electrónico"
                          required
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-container>
                <br />
                <small>* Indica que el campo es requerido</small>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed @click.native="returnHomePage">Cerrar</v-btn>
                <v-btn
                  color="primary darken-4"
                  :loading="$store.state.operationInProgress"
                  @click="saveCliente"
                  >Guardar</v-btn
                >
              </v-card-actions>
              <v-alert
                :value="$store.state.operationSuccess"
                color="success"
                icon="check_circle"
                transition="scale-transition"
                >{{ mensajeCliente }}</v-alert
              >
              <v-alert
                :value="$store.state.operationFailed"
                color="error"
                icon="warning"
                transition="scale-transition"
              >
                <span v-html="$store.state.errorMessage"></span>
              </v-alert>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
//Services;
import clienteService from "@/services/clienteService";
import catalogoService from "@/services/catalogoServices";

export default {
  watch: {
    // call method if the route changes
    $route: "reiniciar",
  },
  data() {
    return {
      mensajeCliente: "Cliente guardado con éxito",
      paises: [{ paisId: 146, nombre: "MÉXICO" }],
      loadingMunicipios: false,
      entidades: [],
      municipios: [],
      sucursal: {
        sucursalId: 0,
        nombreSucursal: "",
      },
      cliente: {
        clienteId: 0,
        nombreCompletoCliente: "",
        domicilio: "",
        colonia: "",
        codigoPostal: "",
        paisId: 146,
        entidadId: 11,
        municipioId: null,
        telefonoParticular: "",
        telefonoCelular: "",
        correoContacto: "",
        descuento: 0,
        municipio: {
          municipioId: 0,
          nombreMunicipio: "",
        },
        sucursalId: 0,
      },
    };
  },
  beforeCreate() {
    let usuarioId = localStorage.getItem("usuarioId");
    if (!usuarioId) {
      this.$router.push({ path: "public-login" });
    }
  },
  created() {
    this.reload();
    this.reiniciar();
  },
  methods: {
    reiniciar() {
      let self = this;
      if (window.location.href.indexOf("public-form-cliente") > -1) {
        self.sucursal.sucursalId = this.$route.query.sucursalId;
        self.sucursal.nombreSucursal = this.$route.query.nombreSucursal;
        self.cliente.sucursalId = this.$route.query.sucursalId;

        self.$nextTick(() => {
          self.getEntidades();
        });
      }
    },
    reload(){
      if(localStorage.getItem("loaded") === null)
      {
          window.location.reload();
          localStorage.setItem("loaded", "true");
      }
      
       
    },
    setMunicipio(municipio) {
      this.cliente.municipioId = municipio.municipioId;
    },
    getEntidades() {
      let self = this;

      catalogoService
        .getEntidadesPublic()
        .then((result) => {
          self.entidades = result;
          self.getMunicipios(11);
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        });
    },
    getMunicipios(entidadId) {
      let self = this;

      self.loadingMunicipios = true;

      if (typeof entidadId === "undefined") {
        return;
      }
      catalogoService
        .getMunicipiosPublic(entidadId)
        .then((result) => {
          self.municipios = result;
          if (self.cliente.clienteId === 0) {
            let municipio = self.municipios.find((m) => m.municipioId == 340);
            self.cliente.municipio = municipio;
            self.cliente.municipioId = 340;
          }
        })
        .catch((e) => {
          console.log(e);
          self.operationFailed(e);
        })
        .finally(() => {
          self.loadingMunicipios = false;
        });
    },
    saveCliente() {
      let self = this;

      if (self.$refs.formCliente.validate()) {
        self.operationStart();

        self.addCliente();
      }
    },
    addCliente() {
      let self = this;

      clienteService
        .addPublic(self.cliente)
        .then((result) => {
          self.mensajeCliente = "Cliente guardado con éxito";
          self.operationSuccess();
          self.$store.state.successMessage = "Cliente guardado con éxito";

          //Enviar tipo producto al componente padre
          self.$emit("onClienteAdded", result);

          setTimeout(() => {
            self.returnHomePage();
            //self.resetForm();
          }, 1500);
        })
        .catch((e) => {
          self.operationFailed(e);
          console.log(e);
        });
    },
    resetForm() {
      let self = this;
      self.operationReset();
      self.$refs.formCliente.resetValidation();
      self.entidades = [];
      self.municipios = [];
      self.cliente.clienteId = 0;
      self.cliente.nombreCompletoCliente = "";
      self.cliente.domicilio = null;
      self.cliente.colonia = null;
      self.cliente.codigoPostal = "";
      self.cliente.paisId = 146;
      self.cliente.entidadId = 11;
      self.cliente.municipioId = 340;
      self.cliente.telefonoParticular = "";
      self.cliente.telefonoCelular = "";
      self.cliente.correoContacto = "";
      self.cliente.descuento = 0;
      self.cliente.municipio = {
        municipioId: 0,
        nombreMunicipio: "",
      };
      self.sucursal.sucursalId = 0;
      self.sucursal.nombreSucursal = "";
    },
    returnHomePage() {
      this.resetForm();
      localStorage.removeItem('loaded');
      this.$router.push({ path: "public-home" });
    },
  },
};
</script>
